/**
 * Haversine formula — great-circle distance between two lat/lon points.
 * @param {number} lat1
 * @param {number} lon1
 * @param {number} lat2
 * @param {number} lon2
 * @returns {number} distance in miles
 */
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // Earth radius in miles
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * @param {number} distanceMiles
 * @param {number} costPerMile  - e.g. 0.85 for FSL, 1.10 for Warehouse
 * @returns {number} estimated shipping cost in USD
 */
export function estimateShippingCost(distanceMiles, costPerMile) {
  return distanceMiles * costPerMile;
}

/**
 * Delivery day rules:
 *   On-Site:   same day (stock is at the customer's own site)
 *   FSL:       <100 mi → 1 day, <300 mi → 2 days, ≥300 mi → 3 days
 *   Warehouse: <100 mi → 2 days, <300 mi → 3 days, ≥300 mi → 4 days
 *   Vendor:    always "5–7 days"
 *
 * @param {number} distanceMiles
 * @param {'FSL'|'Warehouse'|'On-Site'|'Vendor'} locationType
 * @returns {string} human-readable delivery estimate
 */
export function estimateDeliveryDays(distanceMiles, locationType) {
  if (locationType === 'Vendor') return '5–7 days';
  if (locationType === 'On-Site') return 'Same day';

  if (locationType === 'FSL') {
    if (distanceMiles < 100) return '1 day';
    if (distanceMiles < 300) return '2 days';
    return '3 days';
  }

  // Warehouse
  if (distanceMiles < 100) return '2 days';
  if (distanceMiles < 300) return '3 days';
  return '4 days';
}
